import { ITimeLineConfig } from 'Modules'

import { SettingEnum } from './setting'

export const enum NftPropertyEnum {
  TOKEN_NAME = 1,
  COLLECTION_NAME = 2,
  TOKEN_SYMBOL = 3,
  COLLECTION_ADDRESS = 4,
  TOKEN_METADATA = 5,
  TOKEN_ICON_URI = 6,
  TOKEN_ADDRESS = 7,
}

export enum TermsFlowEnum {
  PURCHASE = 1,
  STAKING = 2,
  RENTAL = 3,
}

export const NFT_INIT = [
  {
    id: NftPropertyEnum.TOKEN_NAME,
    name: 'Property Token Name',
    value: '',
  },
  {
    id: NftPropertyEnum.COLLECTION_NAME,
    name: 'Property Collection Name',
    value: '',
  },
  {
    id: NftPropertyEnum.TOKEN_SYMBOL,
    name: 'Property Token Symbol',
    value: '',
  },
  {
    id: NftPropertyEnum.COLLECTION_ADDRESS,
    name: 'Property Collection address',
    value: '',
  },
  {
    id: NftPropertyEnum.TOKEN_METADATA,
    name: 'Property Token Metadata',
    value: '',
  },
  {
    id: NftPropertyEnum.TOKEN_ICON_URI,
    name: 'Property Token Icon URI',
    value: '',
  },
]

export enum PTOTypeEnum {
  PTO = 'PTO',
  RENTAL_PTO = 'RENTAL_PTO',
}

export const PTO_TYPE_OPTIONS = [
  { value: PTOTypeEnum.PTO, label: 'PTO' },
  { value: PTOTypeEnum.RENTAL_PTO, label: 'Rental PTO' },
]

export const RENTAL_FREQUENCY_OPTIONS = [
  process.env.REACT_APP_APP_NAME !== 'MeyFi_Production'
    ? { value: 300, label: 'Every 5 minutes (Test only)' }
    : undefined,
  { value: 2592000, label: 'Monthly (30 days)' },
  { value: 7776000, label: 'Quarterly (90 days)' },
  { value: 15552000, label: 'Semi-Annually (180 days)' },
  { value: 23328000, label: '9 Months (270 days)' },
  { value: 31536000, label: 'Annually (365 days)' },
].filter(Boolean) as { value: number; label: string }[]

export const RENTAL_TOKEN_OPTIONS = [
  { value: 'USDC', label: 'USDC' },
  { value: 'MEY', label: 'MEY' },
]

export const TOKEN_ADDRESS_MAP: Record<string, SettingEnum> = {
  USDC: SettingEnum.USDC_TOKEN_ADDRESS,
  MEY: SettingEnum.MEY_TOKEN_ADDRESS,
}

export const TOKEN_DECIMALS_MAP: Record<string, number> = {
  USDC: 6,
  MEY: 18,
}

export const DEFAULT_TOKEN_DECIMALS = 6

export const getTokenDecimals = (tokenSymbol: string): number =>
  TOKEN_DECIMALS_MAP[tokenSymbol] ?? DEFAULT_TOKEN_DECIMALS

export const enum TokenizeStatusEnum {
  INACTIVE = 1,
  ACTIVE = 2,
}

export const enum TokenizeMintStatusEnum {
  IDLE = 1,
  MINTING = 2,
  COMPLETED = 3,
  FAILED = 4,
}

export const MINT_STATUS_CONFIG: Record<TokenizeMintStatusEnum, { label: string; color: string }> =
  {
    [TokenizeMintStatusEnum.IDLE]: { label: 'Idle', color: 'default' },
    [TokenizeMintStatusEnum.MINTING]: { label: 'Minting', color: 'processing' },
    [TokenizeMintStatusEnum.COMPLETED]: { label: 'Completed', color: 'success' },
    [TokenizeMintStatusEnum.FAILED]: { label: 'Failed', color: 'error' },
  }

export const enum PropertyTypeEnum {
  HOUSE = 1,
  APARTMENT = 2,
  LAND = 3,
}

export const enum PropertyFieldEnum {
  TYPE = 1,
  LOCATION = 2,
  PROPERTY_VALUE = 3,
  AREA = 4,
  PRICE_PER_SQM = 5,
  BEDS = 6,
  BATHS = 7,
  YEAR_BUILT = 8,
  ANNUAL_GROSS_RENTAL_YIELD = 9,
  ANNUAL_ASSET_APPRECIATION = 10,
  TOTAL_PROJECTED_GROSS_YIELD = 11,
  FLOORS = 12,
  TOTAL_CLAIMED_TOKENS = 13,
  INVESTMENT_PERIOD = 14,
  BASIC_APY = 15,
  BOOSTED_APY = 16,
}

export const PROPERTY_ITEMS = [
  {
    label: 'Location',
    field: 'location',
    type: 'string',
  },
  {
    label: 'Property Value',
    field: 'propertyValue',
    min: 0,
    type: 'number',
    addOnBefore: '$',
    addOnAfter: 'USDC',
  },
  {
    label: 'Area',
    field: 'area',
    min: 0,
    type: 'number',
    addOnAfter: 'SQM',
  },
  {
    label: 'Price Per SQM',
    field: 'pricePerSQM',
    min: 0,
    type: 'number',
    addOnBefore: '$',
    addOnAfter: 'USDC',
  },
  {
    label: 'Beds',
    field: 'beds',
    min: 0,
    type: 'number',
  },
  {
    label: 'Baths',
    field: 'baths',
    min: 0,
    type: 'number',
  },
  {
    label: 'Year Built',
    field: 'yearBuild',
    min: 0,
    type: 'number',
  },
  {
    label: 'Annual Gross Rental Yield',
    field: 'annualGrossRentalYield',
    min: 0,
    type: 'percent',
    addOnAfter: '%',
  },
  {
    label: 'Annual Asset Appreciation',
    field: 'annualAssetAppreciation',
    min: 0,
    type: 'percent',
    addOnAfter: '%',
  },
  {
    label: 'Total Projected Gross Yield',
    field: 'totalProjectedGrossYield',
    min: 0,
    type: 'percent',
    addOnAfter: '%',
  },
  {
    label: 'Floors',
    field: 'floors',
    min: 0,
    type: 'number',
  },
]

export const TIER_ITEMS = [
  { tierId: 0, name: 'Standard', allowNftCollection: true },
  { tierId: 1, name: 'Dolphin', allowNftCollection: true },
  { tierId: 2, name: 'Shark', allowNftCollection: true },
  { tierId: 3, name: 'Whale', allowNftCollection: true },
  { tierId: 4, name: 'SVIP', allowNftCollection: true },
  { tierId: 5, name: 'Whitelist', allowNftCollection: false },
]

export const PHASE_ITEMS = [
  {
    name: 'upcoming',
    required: true,
    enabled: true,
    isPurchasePhase: false,
    isEndTimeUnlimited: false,
  },
  {
    name: 'whitelist',
    isPurchasePhase: true,
    isEndTimeUnlimited: false,
  },
  {
    name: 'calculating',
    isPurchasePhase: false,
    isEndTimeUnlimited: false,
  },
  {
    name: 'fcfs',
    required: true,
    enabled: true,
    isPurchasePhase: true,
    isEndTimeUnlimited: true,
  },
  {
    name: 'end',
    isPurchasePhase: false,
    isEndTimeUnlimited: false,
  },
] as ITimeLineConfig[]
